import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import AttributeCodebookForm from "./AttributeCodebookForm";

export interface State {}

export interface CreateAttributeCodebookFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
}

class CreateAttributeCodebookForm extends React.Component<
  CreateAttributeCodebookFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newAttributeCodebook = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newAttributeCodebook = values;
        }
      });
      return newAttributeCodebook;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <AttributeCodebookForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
      />
    );
  }
}

export default CreateAttributeCodebookForm;
